import { Col, Row } from "antd";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import Victor from "../assets/images/Victor.svg";
import stateWrapper from "../containers/provider";
import { useResponsive } from "../hooks/responsive";
import NavigationModal from "./NavigationModal";

const NavBarMobile = (props) => {
  const [state, setState] = useState({
    isVisible: false,
  });
  const [
    isTabletOrMobileDevice,
    isTabletOrMobile,
    isBigScreen,
    isDesktopOrLaptop,
    isPortrait,
    isRetina,
    isTablet,
  ] = useResponsive();
  const openModal = (event) => {
    console.log(event);
    event.stopPropagation();
    setState({ ...state, isVisible: true });
  };

  const closeModal = () => {
    setState({ ...state, isVisible: false });
  };

  const handleOnClick = (href) => {
    props?.masterStore?.setSelectedBar(href);
  };

  return (
    <>
      <Row
        onClick={closeModal}
        style={{
          marginBottom: 26,
          marginTop: 26,
          marginLeft: 20,
          marginRight: 10,
        }}
      >
        <Col span={19}>
          <Link
            to="/home"
            onClick={() => {
              handleOnClick("/home");
            }}
          >
            <img
              src={Victor}
              style={{
                width: 120,
                height: 30,
                fontFamily: "Arial Rounded MT Bold",
              }}
            />
          </Link>
        </Col>
        <Col span={5}>
          <div onClick={openModal}>
            <svg height="24" viewBox="0 0 30 24" width="30">
              <g fill="#fff">
                <rect height="5.5" rx="2.75" width="29.333333"></rect>
                <path
                  d="m2.75 18.3333333h23.8333333c1.5187831 0 2.75 1.231217 2.75 2.75s-1.2312169 2.75-2.75 2.75h-23.8333333c-1.51878305 0-2.75-1.231217-2.75-2.75s1.23121695-2.75 2.75-2.75zm0-9.16666663h23.8333333c1.5187831 0 2.75 1.23121693 2.75 2.75000003 0 1.518783-1.2312169 2.75-2.75 2.75h-23.8333333c-1.51878305 0-2.75-1.231217-2.75-2.75 0-1.5187831 1.23121695-2.75000003 2.75-2.75000003z"
                  opacity="0.3"
                ></path>
              </g>
            </svg>
          </div>
        </Col>
      </Row>
      <Row align="middle">
        <Col span={5}>
          <NavigationModal onClose={closeModal} isVisible={state.isVisible} />
        </Col>
      </Row>
    </>
  );
};

export default stateWrapper(NavBarMobile);
